import { render, staticRenderFns } from "./custom-form-textarea.vue?vue&type=template&id=6d31fa84&scoped=true"
import script from "./custom-form-textarea.vue?vue&type=script&lang=js"
export * from "./custom-form-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31fa84",
  null
  
)

export default component.exports